/**
 * @module app.config.timetype
 */
class Controller {
  /**
   * @param {gettext} gettext function for dynamic i18n.
   * @ngInject
   */
  constructor(gettext) {
    /**
     * @type {string}
     * @export
     */
    this.timetype;

    /**
     * @type {function(appx.TimetypeChangeEvent)}
     * @export
     */
    this.onChange;

    /**
     * @type {Array<appx.TimetypeEntry>}
     * @export
     */
    this.timetypes = [
      {
        label: gettext('No Time'),
        value: 'no',
      },
      {
        label: gettext('Hiking Time Type'),
        value: 'wander',
      },
      {
        label: gettext('Biking Time Type'),
        value: 'velo',
      },
      {
        label: gettext('Winter Hiking Time Type'),
        value: 'winter_hiking',
      },
      {
        label: gettext('Snowshoe Trekking Time Type'),
        value: 'snowshoe_trekking',
      },
    ];
  }

  /**
   * @export
   * @return {string}
   */
  get label() {
    const timetypeEntry = this.timetypes.find(timetype => timetype.value === this.timetype);
    if (timetypeEntry) {
      return timetypeEntry.label;
    }
    return '';
  }
}


/**
 * @const {!angular.Component}
 */
const component = {
  bindings: {
    'timetype': '<',
    'editable': '<',
    'onChange': '&',
  },
  controller: Controller,
  templateUrl: 'js/app/config/timetype/partial.html'
};

export default angular.module('appConfigTimetypeComponent', [])
  .component('appConfigTimetype', component);
